export default __webpack_public_path__ + "static/media/notification-icn-2.1ec43d21.svg";